import mainLogo from '../../images/Germanica/germanica_logo_main.png';
import squareLogo from '../../images/Germanica/germanica_small_square.png';
import squareLogoLarge from '../../images/Germanica/germanica_full_square.png';
import bannerLogoWhite from '../../images/Germanica/germanica_full_square_white.png';
import banner01 from '../../images/Germanica/germanica_bg_01.jpg';
import banner02 from '../../images/Germanica/germanica_bg_02.jpg';
import banner03 from '../../images/Germanica/germanica_bg_03.jpg';
import car123 from '../../images/Germanica/123_bmw.jpg';
import box123 from '../../images/Germanica/123_germanica.jpg';
import {SliderProducts} from '../../Utilities/SliderProducts';

export const configData = {
    defaultStore: 'Germanica',
    defaultStoreLink: 'pecas.grupogermanica.com.br',
    defaultContactEmail: 'ecommercevw@grupogermanica.com.br',
    whatsappNumber: '19 4042 6804',
    CNPJname: '',
    CNPJ: '',
    CNPJaddress: '',
    launchDate: '01/06/2025',

    multiContact: {},
    searchByPlate: false,

    coupons: [
        // {
        //     coupon: '10PORCENTO',
        //     discountPrice: 0,
        //     discountPercent: 0.1,
        //     freeShipping: false,
        // },
        // {
        //     coupon: '10REAIS',
        //     discountPrice: 10,
        //     discountPercent: 0,
        //     freeShipping: false,
        // },
        // {
        //     coupon: 'FRETEGRATIS',
        //     discountPrice: 0,
        //     discountPercent: 0,
        //     freeShipping: true,
        // },
    ],

    brands: [
        'bmw',
        'jeep',
        'kia',
        'mini',
        'toyota',
        'volkswagen',
        'volvo',
    ],

    homologBrands: [
        'motorcraft',
        'motrio',
        'acdelco',
        'mopar',
        'bproauto',
    ],

    noVehicle: false,

    storeSellersWarehouses: [
        "SAVOL VW CENTRO",
        "BELCAR VW",
        "REVEMAR VW",
        "DISCAUTOL VW CARANDA",
        "REVEMAR VW PARAUAPEBAS",
        "VECOL VW",
        "VIGORITO VW ATACADO",
        "UMUARAMA VW ARAGUAINA",
        "UMUARAMA VW ITUMBIARA",
        "RECREIO BH VW",
        "RECREIO RJ VW",
        "LUSON VW",
        "LUSON VW TARUMA",
        "EUROKRAFT VW NOVA FRIBURGO",
        "BARIGUI BLUSA VW",
        "BARIGUI CABRAL VW",
        "APIA VW",
        "BARIGUI VW - SAO JOSE (MATRIZ)",
        "UMUARAMA VW CATALAO",
        "ALEMANHA VW",
        "VIVA VW MACEIO",
        "ESTILO VW - POUSO ALEGRE",
        "DOKAR VW - PINDAMONHANGABA",
        "RECREIO VW MG - MILA",
        "COMERI VW",
        "MECAUTOR VW - SANTO ANGELO",
        "BREITKOPF VW BLUMENAU",
        "PAMPEIRO VW - SANTA MARIA",
        "BEVEL VW - MARAU",
        "CARRERA ACELERA VW",
        "Iesa BMW NH",
        "BARIGUI BMW MARINGÁ",
        "GLOBO JEEP CURITIBA",
        "NISSUL GALA JEEP BAGÉ",
        "SAVOL KIA",
        "FABERGE KIA",
        "GLOBO JEEP SC",
        "VIGORITO KIA",
        "UMUARAMA KIA",
        "Iesa JEEP Cachoeirinha",
        "AKTA KIA",
        "BARIGUI KIA CAMPINA SIQUEIRA",
        "NISSUL GALA JEEP PELOTAS",
        "BARIGUI JEEP - TORRES",
        "TOYOTA BOTAFOGO",
        "Iesa VOLVO Azenha",
        "ITVA VOLVO VILA OLIMPIA",
        "SAVOL TOYOTA",
        "TOYOTA GASTÃO VIDIGAL",
        "FABERGE VOLVO MOGI",
        "UMUARAMA TOYOTA ARAGUAINA",
        "UMUARAMA TOYOTA IMPERATRIZ",
        "UMUARAMA TOYOTA RIO VERDE",
        "UMUARAMA TOYOTA CALDAS NOVAS",
        "UMUARAMA TOYOTA MINEIROS",
        "UMUARAMA TOYOTA ITUMBIARA",
        "SULPAR SGA TOYOTA - HAUER",
        "SULPAR SGA TOYOTA - NITEROI"
    ],
    
    disabledSellers: [],

    useMktNames: false,

    endYear: 2025,
    startYear: 1996,

    payment: {
        maxParcels: 6,
        checkoutParcels: {
            0: 1,
            200: 2,
            300: 3,
            600: 4,
            800: 5,
            1000: 6,
        }
    },

    customShipping: {
        deliveryTime: 1,
    },

    productSlider: [
        {
            name: 'Kits',
            img: 'tabKits',
            products: SliderProducts.Kits
        },
        {
            name: 'Óleos',
            img: 'tabOleos',
            products: SliderProducts.Oleos
        },
        {
            name: 'Filtros',
            img: 'tabFiltros',
            products: SliderProducts.Filtros
        },
        {
            name: 'Acessórios',
            img: 'tabAcessorios',
            products: SliderProducts.Acessorios
            },
        {
            name: 'Roupas',
            img: 'tabRoupas',
            products: SliderProducts.Roupas
        }
    ]
}

export const contentData = {
    mainLogo: mainLogo,
    squareLogo: squareLogo,
    bannerImg01: bannerLogoWhite,

    banner01: banner01,
    banner02: banner02,
    banner03: banner03,
    bannerBrands: '',
    aboutUsBg: banner03,

    box123: box123,
    car123: car123,
    
    paymentImg: squareLogoLarge,
    paymentImgMobile: squareLogoLarge,

    bannerSpecial: '',
    bannerSpecialMobile: '',
    imgSepcial: '',
    imgSepcialMobile: '',

    bannerHighlight: 'Compre peças originais <span style="font-weight: bold;">Volkswagen</span> direto das concessionárias <span style="font-weight: bold;">Germanica</span>.',
    aboutUs: {
        title: 'Sobre nós',
        content: [
            'Criado em 1970, com a inauguração da sua primeira operação Volkswagen em Paraguaçu Paulista, a Germânica Volkswagen nasceu com o sonho de ser uma concessionária inovadora, oferecendo qualidade excepcional. Em 1998, expandiu sua atuação e chegou à região com a loja de Mogi Mirim.',
            'Em 2005, a Germânica Volkswagen se transformou no Grupo Germânica, com a criação da Nipônica Toyota, e rapidamente ampliou sua presença no mercado. A expansão continuou com a Tennessee Harley-Davidson em 2011, a Germânica BMW em 2013, a Germânica KIA em 2018, a Escandinávia Volvo em 2019, a Jeep Germânica em 2020, a GWM e a Ram em 2023, e mais recentemente, em 2025, com a chegada da Germânica Omoda Jaecoo.',
            'Atualmente, contamos com mais de 42 lojas distribuídas nos estados de São Paulo, Minas Gerais e Paraná, oferecendo veículos 0km de 12 marcas e uma ampla variedade de seminovos.',
            'Com uma trajetória de mais de 54 anos, nos consolidamos como um dos principais grupos de concessionárias do interior, destacando-nos pela excelência em veículos e serviços. Nosso compromisso com a qualidade e a inovação nos tornou referência no mercado de carros novos e seminovos.',
            'Procure pelo Grupo Germânica nas concessionárias Germânica Volkswagen, Germânica BMW, Nipônica Toyota, Tennessee Harley-Davidson, Germânica KIA, Jeep Germânica, Germânica Ram, Volvo Escandinávia, GWM Germânica e Germânica Omoda Jaecoo.'
        ],
        link: 'https://www.grupogermanica.com.br/institucional',
        linkCta: 'Saiba mais',
    },

    socialMedia: {
        Instagram: 'https://www.instagram.com/grupogermanica/',
        Facebook: 'https://www.facebook.com/grupogermanica',
        LinkedIn: '',
        Youtube: 'https://www.youtube.com/@GrupoGermanica',
        Twitter: '',
    },

    footerContent: [],
}